<template>
  <div class="container">
    <div class="module_title">
      <span class="font_weight_700 size18">课程概览</span>
      <div class="rightBox padding_right_10">
        <span>投放状态：</span>
        <el-select v-model="postForm1.audit_state" placeholder="" style="width:200px">

          <el-option v-for="(item, index) in options1.filter(item => ['', '0', '2'].includes(item.dictionary_key))"
            :key="index" :label="item.dictionary_value" :value="item.dictionary_key">
          </el-option>

        </el-select>
        <span class="margin_left_10">选择企业：</span>
        <el-select v-model="postForm1.enterprise_id" placeholder="" style="width:200px">
          <!-- <el-option :label="'全部企业'"
                     :value="''">
          </el-option> -->
          <el-option-group v-for="(group, index) in options" :key="index" :label="group.label">
            <el-option v-for="(item, index) in group.options" :key="index" :label="item.enterprise_name"
              :value="item.enterprise_id">
            </el-option>
          </el-option-group>
        </el-select>
        <el-button type="primary" icon="el-icon-search" class="margin_left_10" @click="search">查询</el-button>
      </div>

    </div>
    <div class="content">
      <div class="left_list" :style="{ width: left_list_width }">
        <div class="left_list_title">
          <template v-if="leftFoldshow == true">
            <div>
              <span class="dot userzudot"></span>
              <span v-show="leftFoldshow == true">职位列表</span>
            </div>
            <i @click="foldshowclick('left')" class="el-icon-s-fold xiaosho" style="font-size: 20px;"></i>
          </template>
          <i v-else @click="foldshowclick('left')" class="el-icon-s-unfold xiaosho" style="font-size: 20px;flex: 1;"></i>

        </div>
        <div class="joblist" v-if="leftFoldshow">
          <template v-if="leftList.length > 0">
            <ul v-infinite-scroll="getList1" infinite-scroll-disabled="disabled">
              <li class="xiaosho list_item" :class="{ 'list_item_active': left_list_value == item.recruitment_id }"
                v-for="(item, index) in leftList" :key="index" @click="listValueChange('left', index, item)">
                <p class="text_ellipsis">
                  {{ item.position_name }}
                </p>
                <p class="text_ellipsis color7b7b7b size11">
                  {{ item.enterprise_name }}
                </p>
                <p class="text_ellipsis color7b7b7b size11">
                  {{ item.position_effective_start}} - {{item.position_effective_end }}
                </p>
                <p class="text_ellipsis color7b7b7b size11 box4">
                  <span>
                    课程： {{ item.outline_name }}
                  </span>
                  <template v-if="item.audit_state == '0'">
                    <span class="color_rgb_19_179_231" @click="oper('1', item)">
                      <i class="el-icon-plus pointer"></i> 投放课程
                    </span>

                  </template>
                  <template v-else>
                    <!-- <span class="color_red pointer">
                      <i class="el-icon-minus"></i> 结束投放
                    </span> -->
                  </template>

                </p>
              </li>

            </ul>
            <p v-if="infinite_loading" style="text-align: center; padding: 10px 0;">加载中...</p>
            <p v-if="noMore" style="text-align: center; padding: 10px 0;">没有更多了</p>
          </template>
          <template v-else>
            <div class="empty">
              <span>
                暂无职位信息数据
              </span>
            </div>
          </template>
        </div>
        <div class="joblist" v-else></div>
      </div>
      <div class="centerBox">

        <div class="center_title font_weight_600">课程信息</div>
        <div class="info_box">
          <div class="top_info">
            <div class="left">
              <div class="box left_f">
                <p class="font_weight_600">
                  线上学员(人)
                </p>
                <p class="color_primary">
                  50
                </p>
              </div>
              <div class="box left_r">
                <p class="font_weight_600">
                  课程收益(￥)
                </p>
                <p class="color_red">
                  100
                </p>
              </div>
            </div>
            <div class="right">
              <div class="box">
                <div class="btn btn1 after">
                  <el-button type="text" class="">查看学员</el-button>
                </div>
                <div class="btn btn2">
                  <el-button type="text" class="">全部订单</el-button>
                </div>
              </div>
              <div class="box">
                <p>
                  <span>
                    投放时间：
                  </span>
                  <span>
                    {{ detail.ctime_str }}
                  </span>

                </p>
                <p class="margin_left_20">
                  <span>
                    有效期限：
                  </span>
                  <span>
                    {{ detail.position_effective_start}} - {{detail.position_effective_end }}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="courseInfo">
            <preview1 ref="preview1" :recruitmentId="postForm2.recruitment_id"></preview1>
          </div>
        </div>
      </div>
      <div class="right_list" :style="{ width: right_list_width }">
        <div class="box1">
          <div class="title font_weight_600">
            投放申请
          </div>
          <div class="content">
            <p>
              海量职位课程期待您来投放...
            </p>
            <p>
              <el-button type="text" @click="jump('0')">
                <span class="margin_right_5">申请</span>
                <img src="@/assets/cr_request_icon.png" alt="">
              </el-button>
              <el-button type="text" class="margin_left_20 color_rgb_214_224_59" @click="jump('1')">
                <span class="margin_right_5">查看申请记录</span>

              </el-button>
            </p>
          </div>
          <div class="bgcBox"></div>
        </div>
        <div class="box2">
          <div class="title font_weight_600">
            收益统计
          </div>
          <div class="content">
            <div class="con">
              <div class="title">
                今日收益
              </div>
              <div class="num color_red  size16">
                {{ 100 }}元
              </div>
            </div>
            <div class="con">
              <div class="title">
                本月收益
              </div>
              <div class="num color_red  size16">
                {{ 30000 }}元
              </div>
            </div>
            <div class="con">
              <div class="title">
                今日订单
              </div>
              <div class="num color_primary  size16">
                {{ 100 }}条
              </div>
            </div>
            <div class="con">
              <div class="title">
                本月订单
              </div>
              <div class="num color_primary  size16">
                {{ 10000 }}+条
              </div>
            </div>
          </div>

        </div>
        <div class="box3">
          <div class="title font_weight_600">
            <span>
              投放统计
            </span>
            <el-button type="text" @click="jump('2')">
              投放数据
            </el-button>
          </div>
          <div class="content">
            <div class="row1">
              <div class="con after">
                <div class="title">
                  可投放公司
                </div>
                <div class="num size16">
                  {{TFStatistics.uninvest_enterprise_num}}
                </div>
              </div>
              <div class="con">
                <div class="title">
                  投放到期公司
                </div>
                <div class="num color_red size16">
                  {{TFStatistics.close_enterprise_num}}
                </div>
              </div>
            </div>
            <div class="row2">
              <div class="con">
                <div class="title">
                  可投放职位
                </div>
                <div class="num color_red size16">
                  {{TFStatistics.uninvest_recruitment_num}}
                </div>
              </div>
              <div class="con">
                <div class="title">
                  已关闭职位
                </div>
                <div class="num color_primary size16">
                  {{TFStatistics.close_recruitment_num}}
                </div>
              </div>
              <div class="con">
                <div class="title">
                  投放中职位
                </div>
                <div class="num color_primary size16">
                  {{TFStatistics.invest_recruitment_num}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <selectCourse ref="selectCourseRef" @ok="ok('2')"></selectCourse>
  </div>
</template>

<script>
import preview1 from './components/preview1.vue'
import selectCourse from '@/components/launchList/components/selectCourse.vue'//课程
export default {
  components: {
    preview1,
    selectCourse,
  },
  data() {
    return {
      // 招聘状态
      options1: [],
      options: JSON.parse(localStorage.getItem('entinfolist')),
      loading1: false,
      infinite_loading: false,
      leftListTotal: 0,
      leftListCurrentPage: 0,
      leftListPagesize: 10,
      leftList: [],
      left_list_width: '300px',
      leftFoldshow: true,
      left_list_value: '',
      rightList: [],
      right_list_width: '300px',
      rightFoldshow: true,
      right_list_value: '',

      detail: {},

      TFStatistics:{},//投放统计数据

      // 左侧列表参数
      postForm1: {
        page: 1,
        limit: 10,
        // "recruitment_state": "1",//招聘状态 是否开启  1：是 2：否
        "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
        'audit_state': ''
      },
      // 中间上方详情参数
      postForm2: {
        recruitment_id: '',
      },
      // // 中间列表参数
      // postForm2: {
      //     page: 1,
      //     limit: 10,
      //     "name": "",//视频课程名称
      //     "outline_id": "",//主课程详情 ID
      //     "contents_id": "",//课程大纲目录 ID
      //     "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
      // },
    }
  },
  computed: {
    noMore() {
      return this.leftList.length >= this.leftListTotal && !this.infinite_loading
    },
    disabled() {
      return this.infinite_loading || this.noMore
    }
  },
  created() {
    this.getList1(true)
    this.getDictsData("HR-KJ-KC-TFZT", "options1");
    this.getTFStatistics()
  },
  methods: {
    // 获取数据字典值
    async getDictsData(dict, optionsNmae) {
      let options = [];
      await this.$tools
        .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
          data: {
            dictionary_code: dict,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            options = res.data.data.dictionary_detail;
            // 如果是投放状态options1，在前面添加"全部"选项
            if (optionsNmae === 'options1') {
              options.unshift({
                dictionary_key: '',
                dictionary_value: '全部'
              });
            }
          } else {
            // this.$message({ type: "error", message: res.data.msg });
          }
        })
        .catch((err) => {
          // this.$message({ type: "error", message: err });
        });
      this[optionsNmae] = options;
    },
    // 选择企业改变
    search(value) {
      console.log(value);
      // this.postForm1.enterprise_id = value
      this.getList1(true)
      this.getTFStatistics()
      // 如果tab在视频课程，则重新获取视频课程
      // if (this.activeName == '1') {
      //     this.currentPage=1
      //     this.getList2()
      // }
    },
    // 跳转
    jump(type) {
      switch (type) {
        case '0'://申请
          this.$router.push({ path: '/index/biddingApplication' })
          break;
        case '1'://查看申请记录
          this.$router.push({ path: '/index/bidApplicationRecord' })
          break;
        case '2'://投放列表
          this.$router.push({ path: '/index/launchList' })
          break;
      }
    },
    // 左右列表点击收缩
    foldshowclick(type) {
      this[type + 'Foldshow'] = !this[type + 'Foldshow'];
      switch (this[type + 'Foldshow']) {
        case true:
          this[type + '_list_width'] = type == "left" ? "300px" : "400px";

          break;
        case false:

          this[type + '_list_width'] = "35px";
          break;
      }
    },
    // 左右列表点击
    listValueChange(type, index, item) {
      switch (type) {
        case 'left':
          this[type + '_list_value'] = item.recruitment_id;
          // 给添加视频课程赋值

          this.$nextTick(() => {
            this.$refs.preview1.getData(item.outline_id)
          })
          this.getDetail()


          break;

        default:
          break;
      }

    },
    // 左侧列表
    getList1(init) {
      if (init) {
        this.leftListCurrentPage = 0
      }
      this.infinite_loading = true;
      this.leftListCurrentPage++
      this.postForm1.page = this.leftListCurrentPage
      this.postForm1.limit = this.leftListPagesize
      this.$tools
        .asyncPost(
          this,
          this.$baseUrl.courseOverviewRecruitmentList, {
          data: this.postForm1
        }).then((res) => {
          if (res.data.code == 0) {
            if (init) {
              this.leftList = res.data.data.data
            } else {
              let arr = this.leftList.concat(res.data.data.data)
              this.leftList = arr
            }



            if (init && this.leftList.length > 0) {
              this.left_list_value = this.leftList[0].recruitment_id
              // 给添加视频课程赋值
              this.$refs.preview1.getData(this.leftList[0].outline_id)
              this.getDetail()

            } else {
              this.$refs.preview1.getData('')
            }
            this.leftListTotal = res.data.data.total

          } else {
            this.$message({ type: "error", message: res.data.msg });
          }
          this.infinite_loading = false;
        }).catch((err) => {
          this.infinite_loading = false;
        });
    },
    // 中间详情
    getDetail() {
      this.postForm2.recruitment_id = this.left_list_value
      this.$tools
        .asyncPost(
          this,
          this.$baseUrl.courseOverviewRecruitmentGet, {
          data: this.postForm2
        }).then((res) => {
          if (res.data.code == 0) {
            this.detail = res.data.data


          } else {
            this.$message({ type: "error", message: res.data.msg });
          }
        })
        .catch((err) => {
          // this.$message({ type: "error", message: err });

        })
    },
    oper(type, row) {

      switch (type) {
        case '1'://投放
          this.$refs.selectCourseRef.dialogVisible = true
          this.$refs.selectCourseRef.init(row)
          // this.$tools
          //     .asyncPost(
          //         this,
          //         this.$baseUrl.launchListEdit, {
          //         data: {
          //             "recruitment_id": row.recruitment_id,
          //             "audit_state": "1",

          //         }
          //     }).then((res) => {
          //         if (res.data.code == 0) {
          //             this.$message({ type: "success", message: '投放申请成功' });
          //             // 重新渲染右侧列表

          //             this.getList2(true)

          //         } else {
          //             this.$message({ type: "error", message: res.data.msg });
          //         }
          //     })
          break;
        case '2':


          break;

        default:
          break;
      }
    },
    ok(type) {
      switch (type) {
        case '1':
          this.getList2(true)
          break;
        case '2':
          this.getList1(true)
          break;
        default:
          break;
      }
    },
    //  获取投放统计
    getTFStatistics(){
      let tmpForm = {
        enterprise_id:this.postForm1.enterprise_id
      }
      this.$tools
          .asyncPost(
              this,
              this.$baseUrl.launchListStatistics, {
                data: tmpForm
              }).then((res) => {
        if (res.data.code == 0) {
          this.TFStatistics = res.data.data


        } else {
          this.$message({ type: "error", message: res.data.msg });
        }
      })
          .catch((err) => {
            // this.$message({ type: "error", message: err });

          })
    }
  }

}
</script>

<style scoped lang="less" src="./index.less"></style>